import React, { useEffect, useState } from "react";
import { useParams, Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { formatDate } from "../helper/DateHelper";
import { toast } from "react-toastify";
import Select from "react-select";
import { selectStyles } from "../helper/SelectStyles";
import { getExpoById } from "../Apis/ExpoAPIs";
import { getImageUrl } from "../Apis/api";
import {
  saveVisitorEnquiry,
  getVisitorEnquiriesByExpo,
} from "../Apis/VisitorEnquiryAPIs";
import {
  saveStallEnquiry,
  getStallEnquiriesByExpo,
} from "../Apis/StallEnquiryAPIs";
import { getStallTypes } from "../Apis/StallTypeAPIs";

const ExpoViewLayer = () => {
  const { id } = useParams();
  const location = useLocation();
  const returnPath = location.state?.from || "/upcoming-expo";
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);

  const [activeTab, setActiveTab] = useState("stall");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [showGroupsModal, setShowGroupsModal] = useState(false);
  const [stallList, setStallList] = useState([]);
  const [visitorList, setVisitorList] = useState([]);
  const [newEntry, setNewEntry] = useState({
    name: "",
    companyName: "",
    mobileNo: "",
    email: "",
    address: "",
    city: "",
    state: "",
    pincode: "",
    remarks: "",
    paymentType: "Free",
    paymentScreenshot: null,
    stallNo: "",
    stallType: "Normal",
  });
  const [stallTypeOptions, setStallTypeOptions] = useState([]);
  const [errors, setErrors] = useState({});

  const productOptions = [
    "Diagnostic & Health Equipment",
    "AC ANIMAL HEALTH",
    "AC AUTOMATION",
    "ANIMAL NUTRITION TECHNOLOGY",
    "Automated Plant and Relevant Software Providers",
    "Feed Manufacturers & Suppliers",
    "BB ACP Sheets",
    "BB Adhesive",
    "BB Air Conditioner",
    "BB Air Ventilators",
  ].map((prod) => ({ value: prod, label: prod }));

  useEffect(() => {
    const fetchDetails = async () => {
      if (!id) return;
      setLoading(true);

      // Fetch main expo details
      const res = await getExpoById(id);
      if (res.status && res.response) {
        const data = res.response?.data || res.response;
        setEvent({
          ...data,
          title: data.expoName || data.title,
        });
      }

      // Fetch counts from API (Disabled due to 404)
      /*
      const stallRes = await getStallEnquiriesByExpo(id);
      if (stallRes.status && stallRes.response) {
        const stalls = stallRes.response?.data || stallRes.response || [];
        setStallList(stalls);
      }

      const visitorRes = await getVisitorEnquiriesByExpo(id);
      if (visitorRes.status && visitorRes.response) {
        const visitors =
          visitorRes.response?.data || visitorRes.response || [];
        setVisitorList(visitors);
      }
      */

      // Fetch stall types
      const typeRes = await getStallTypes();
      if (typeRes.status) {
        const types = typeRes.response?.data || typeRes.response || [];
        setStallTypeOptions(
          types.map((t) => ({
            value: t.stallTypeName || t.name,
            label: t.stallTypeName || t.name
          })),
        );
      }

      setLoading(false);
    };
    fetchDetails();
  }, [id]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "mobileNo") {
      const isDigitsOnly = /^\d*$/.test(value);
      if (!isDigitsOnly || value.length > 10) return;
    }
    setNewEntry((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: null }));
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setNewEntry((prev) => ({ ...prev, paymentScreenshot: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAddEntry = async () => {
    const newErrors = {};
    if (!newEntry.name.trim()) newErrors.name = "Name is Required";
    if (!newEntry.email.trim()) {
      newErrors.email = "Email is Required";
    } else {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      if (!emailRegex.test(newEntry.email)) {
        newErrors.email = "Invalid email address";
      }
    }

    if (activeTab === "stall") {
      if (!newEntry.mobileNo.trim()) {
        newErrors.mobileNo = "Mobile Number is Required";
      } else if (newEntry.mobileNo.length !== 10) {
        newErrors.mobileNo = "Mobile Number must be exactly 10 digits";
      }

      if (!newEntry.stallNo.trim()) {
        newErrors.stallNo = "Stall No is Required";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    if (activeTab === "visitor") {
      const payload = {
        expoId: id,
        name: newEntry.name,
        companyName: newEntry.companyName,
        mobileNo: newEntry.mobileNo,
        email: newEntry.email,
        address: newEntry.address,
        city: newEntry.city,
        state: newEntry.state,
        pincode: newEntry.pincode,
        paymentStatus: newEntry.paymentType,
        paymentScreenshot: newEntry.paymentScreenshot,
        remark: newEntry.remarks,
        status: "Booked",
      };

      const res = await saveVisitorEnquiry(payload);
      if (res.status) {
        toast.success("Visitor registration successful!");
        setShowAddModal(false);
        setErrors({});
        setNewEntry({
          name: "",
          companyName: "",
          mobileNo: "",
          email: "",
          address: "",
          city: "",
          state: "",
          pincode: "",
          remarks: "",
          paymentType: "Free",
          paymentScreenshot: null,
          stallNo: "",
        });
        // Reload counts (Disabled due to 404)
        /*
        const vRes = await getVisitorEnquiriesByExpo(id);
        if (vRes.status && vRes.response) {
          setVisitorList(vRes.response?.data || vRes.response || []);
        }
        */
      }
      return;
    }

    if (activeTab === "stall") {
      const payload = {
        expoId: id,
        name: newEntry.name,
        companyName: newEntry.companyName,
        mobileNo: newEntry.mobileNo,
        email: newEntry.email,
        status: "Interested",
        category: "Technology",
        stallType: newEntry.stallType || "Normal",
        stallNo: newEntry.stallNo,
        sqm: 18,
        products: newEntry.product ? [newEntry.product] : [],
        address: newEntry.address,
        city: newEntry.city,
        state: newEntry.state,
        pincode: newEntry.pincode,
        remark: newEntry.remarks,
        visitorPhoto: newEntry.paymentScreenshot || "",
      };

      const res = await saveStallEnquiry(payload);
      if (res.status) {
        toast.success("Stall enquiry added!");
        setShowAddModal(false);
        setErrors({});
        setNewEntry({
          name: "",
          companyName: "",
          mobileNo: "",
          email: "",
          address: "",
          city: "",
          state: "",
          pincode: "",
          product: "",
          remarks: "",
          paymentType: "Free",
          paymentScreenshot: null,
          stallNo: "",
        });
        // Reload counts (Disabled due to 404)
        /*
        const sRes = await getStallEnquiriesByExpo(id);
        if (sRes.status && sRes.response) {
          setStallList(sRes.response?.data || sRes.response || []);
        }
        */
      }
      return;
    }
  };

  if (loading) return <div>Loading...</div>;
  if (!event) return <div>Event not found</div>;

  return (
    <>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header border-bottom py-16 px-24 d-flex justify-content-between align-items-center"
          style={{ background: "linear-gradient(135deg, #000000 0%, #bb0007 50%, #ed1c24 100%)" }}
        >
          <div className="d-flex align-items-center gap-3">
            <h6 className="text-white mb-0" style={{ fontWeight: "700" }}>
              EXPO DASHBOARD
            </h6>
          </div>
          <div className="d-flex align-items-center gap-2">

            <Link
              to={returnPath}
              className="btn btn-sm bg-white text-danger fw-bold radius-8 d-flex align-items-center gap-2"
            >
              <Icon icon="solar:arrow-left-bold" /> List
            </Link>
          </div>
        </div>

        <div className="card-body p-24">
          {/* Stats Matrix */}

          {/* Event Hero Banner */}
          <div className="card radius-16 border shadow-sm mb-0 overflow-hidden">
            <div className="position-relative w-100" style={{ height: '320px' }}>
              {event.expoImage ? (
                <img
                  src={getImageUrl(event.expoImage)}
                  alt="Expo"
                  className="w-100 h-100 object-fit-cover"
                />
              ) : (
                <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center bg-neutral-200 text-secondary-light">
                  <Icon icon="solar:gallery-bold" className="display-1 mb-2" />
                  <span>No Image Available</span>
                </div>
              )}

              {/* Banner Overlay */}
              <div className="position-absolute bottom-0 start-0 w-100 p-32 d-flex justify-content-between align-items-end"
                style={{ background: 'linear-gradient(to top, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0.4) 50%, transparent 100%)' }}
              >
                <div>
                  <h2 className="text-white fw-bold mb-8">{event.title}</h2>
                  <div className="d-flex align-items-center gap-3">
                    <span className="badge bg-danger text-white px-12 py-6 radius-pill fw-bold border border-white border-opacity-25">
                      <Icon icon="solar:calendar-bold" className="me-1" />
                      {formatDate(event.startDate)} - {formatDate(event.endDate)}
                    </span>
                    <span className="badge bg-white bg-opacity-25 text-white px-12 py-6 radius-pill fw-bold border border-white border-opacity-25 backdrop-blur-sm" style={{ backdropFilter: 'blur(4px)' }}>
                      <Icon icon="solar:map-point-bold" className="me-1" />
                      {event.venue}
                    </span>
                  </div>
                </div>
                <div className="text-end">
                  <span className={`badge ${event.isActive ? 'bg-success' : 'bg-danger'} text-white px-20 py-10 radius-pill fw-bold shadow-lg`}>
                    {event.isActive ? 'ACTIVE' : 'INACTIVE'}
                  </span>
                </div>
              </div>
            </div>

            <div className="p-32">
              {/* Details Grid starts here */}
              <div className="row gy-4 mb-24">
                {/* Row 1 */}
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:square-academic-cap-bold" className="text-primary text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Total Selling Space</span>
                      <span className="text-dark fw-bold">{event.hallSqm} Sqm</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:ticket-bold" className="text-danger text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Entry Type</span>
                      <span className="text-dark fw-bold">{event.entryType} Entry</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:wad-of-money-bold" className="text-success text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">SQM Rate</span>
                      <span className="text-dark fw-bold">₹{event.sqmRate || 0} / Sqm</span>
                    </div>
                  </div>
                </div>

                {/* Row 2 */}
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:user-speak-bold" className="text-info text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1"> Event Managers</span>
                      <span className="text-dark fw-bold">
                        {Array.isArray(event.eventManager)
                          ? event.eventManager.map((m) => m.name || m).filter(Boolean).join(", ")
                          : (typeof event.eventManager === "object" ? (event.eventManager?.name || "-") : (event.eventManager || "-"))}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:clock-circle-bold" className="text-warning text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Event Timings</span>
                      <span className="text-dark fw-bold">{event.startTime || "-"} to {event.endTime || "-"}</span>
                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:shop-bold" className="text-purple text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Total Stalls</span>
                      <span className="text-dark fw-bold">{event.numberOfStalls || 0} Stalls</span>
                    </div>
                  </div>
                </div>

                {/* Row 3 */}
                {/* <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:users-group-rounded-bold" className="text-info text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Visitor Slots</span>
                      <span className="text-dark fw-bold">{event.visitorSlot || 0} Slots</span>
                    </div>
                  </div>
                </div> */}
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:box-bold" className="text-primary text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Type of exhibition</span>
                      <span className="text-dark fw-bold d-block">
                        {typeof event.category === "object" ? event.category.name : event.category || "N/A"}
                      </span>

                    </div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:tag-bold" className="text-danger text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Products</span>
                      <div className="d-flex flex-wrap gap-1 mt-1 align-items-center">
                        {event.products && event.products.length > 0 ? (
                          event.products.slice(0, 2).map((p, idx) => (
                            <span key={idx} className="badge bg-light text-dark border px-8 py-4 radius-4" style={{ fontSize: '10px' }}>
                              {typeof p === 'object' ? p.productName : p}
                            </span>
                          ))
                        ) : (
                          <span className="text-secondary-light text-xs italic">None</span>
                        )}
                        {event.products?.length > 2 && (
                          <span
                            className="badge bg-danger-50 text-danger-600 border border-danger-100 px-8 py-4 radius-4 cursor-pointer transition-all hover-scale-105"
                            style={{ fontSize: '10px', cursor: 'pointer' }}
                            onClick={() => setShowProductsModal(true)}
                          >
                            +{event.products.length - 2}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="d-flex align-items-start gap-3">
                    <div className="bg-light radius-8 p-10 d-flex align-items-center justify-content-center">
                      <Icon icon="solar:users-group-rounded-bold" className="text-info text-xl" />
                    </div>
                    <div>
                      <span className="text-secondary-light text-xs fw-bold uppercase d-block mb-1">Groups</span>
                      <div className="d-flex flex-wrap gap-1 mt-1 align-items-center">
                        {event.groups && event.groups.length > 0 ? (
                          event.groups.slice(0, 2).map((g, idx) => (
                            <span key={idx} className="badge bg-light text-dark border px-8 py-4 radius-4" style={{ fontSize: '10px' }}>
                              {typeof g === 'object' ? g.groupName : g}
                            </span>
                          ))
                        ) : (
                          <span className="text-secondary-light text-xs italic">None</span>
                        )}
                        {event.groups?.length > 2 && (
                          <span
                            className="badge bg-danger-50 text-danger-600 border border-danger-100 px-8 py-4 radius-4 cursor-pointer transition-all hover-scale-105"
                            style={{ fontSize: '10px', cursor: 'pointer' }}
                            onClick={() => setShowGroupsModal(true)}
                          >
                            +{event.groups.length - 2}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>

                {/* Public Exhibition Links */}
                <div className="col-12">
                  <div className="p-20 radius-12 border d-flex flex-column gap-16"
                    style={{ background: "linear-gradient(135deg, rgba(237, 28, 36, 0.05) 0%, rgba(0, 0, 0, 0.02) 100%)", borderColor: "rgba(237, 28, 36, 0.15)" }}
                  >
                    <div className="d-flex align-items-center gap-3">
                      <div className="bg-white radius-8 p-8 border d-flex align-items-center justify-content-center shadow-xs">
                        <Icon icon="solar:link-bold" className="text-danger text-xl" />
                      </div>
                      <div>
                        <h6 className="text-sm fw-bold text-dark mb-0 uppercase">Public Exhibition Registration Links</h6>
                      </div>
                    </div>

                    <div className="row gy-3">
                      {/* Visitor Link */}
                      <div className="col-md-6">
                        <div className="bg-white p-12 radius-8 border d-flex align-items-center justify-content-between gap-3">
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <span className="text-secondary-light text-xxs fw-bold uppercase d-block mb-4">Visitor Registration Link</span>
                            <span className="text-danger fw-bold text-xs d-block text-truncate">
                              {event.slug 
                                ? `https://prompttradefairs.com/upcoming-exhibitions/${event.slug}?formType=visitor`
                                : "No slug generated yet"
                              }
                            </span>
                          </div>
                          {event.slug && (
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(`https://prompttradefairs.com/upcoming-exhibitions/${event.slug}?formType=visitor`);
                                toast.success("Visitor link copied!");
                              }}
                              className="btn btn-sm btn-danger-focus text-danger-main d-flex align-items-center justify-content-center radius-8"
                              style={{ width: "32px", height: "32px", padding: 0 }}
                              title="Copy Visitor Link"
                            >
                              <Icon icon="solar:copy-bold" className="text-md" />
                            </button>
                          )}
                        </div>
                      </div>

                      {/* Stall Link */}
                      <div className="col-md-6">
                        <div className="bg-white p-12 radius-8 border d-flex align-items-center justify-content-between gap-3">
                          <div style={{ minWidth: 0, flex: 1 }}>
                            <span className="text-secondary-light text-xxs fw-bold uppercase d-block mb-4">Stall Booking Link</span>
                            <span className="text-danger fw-bold text-xs d-block text-truncate">
                              {event.slug 
                                ? `https://prompttradefairs.com/upcoming-exhibitions/${event.slug}?formType=stall`
                                : "No slug generated yet"
                              }
                            </span>
                          </div>
                          {event.slug && (
                            <button
                              onClick={() => {
                                navigator.clipboard.writeText(`https://prompttradefairs.com/upcoming-exhibitions/${event.slug}?formType=stall`);
                                toast.success("Stall link copied!");
                              }}
                              className="btn btn-sm btn-danger-focus text-danger-main d-flex align-items-center justify-content-center radius-8"
                              style={{ width: "32px", height: "32px", padding: 0 }}
                              title="Copy Stall Link"
                            >
                              <Icon icon="solar:copy-bold" className="text-md" />
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Website Link */}
                {event.websiteLink && (
                  <div className="col-12">
                    <div className="p-16 radius-12 border d-flex align-items-center justify-content-between flex-wrap gap-3"
                      style={{ background: "linear-gradient(135deg, rgba(34, 197, 94, 0.05) 0%, rgba(0, 0, 0, 0.02) 100%)", borderColor: "rgba(34, 197, 94, 0.15)" }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        <div className="bg-white radius-8 p-8 border d-flex align-items-center justify-content-center shadow-xs">
                          <Icon icon="solar:global-bold" className="text-success text-xl" />
                        </div>
                        <div>
                          <h6 className="text-sm fw-bold text-dark mb-4 uppercase">Website Link</h6>
                          <a href={event.websiteLink} target="_blank" rel="noopener noreferrer" className="text-success fw-bold text-sm text-decoration-none">
                            {event.websiteLink}
                          </a>
                        </div>
                      </div>
                      <a
                        href={event.websiteLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-success d-flex align-items-center gap-2 radius-8 fw-bold px-16 py-8 shadow-sm transition-all hover-scale-105"
                        style={{ background: "#22c55e", border: "none" }}
                      >
                        <Icon icon="solar:arrow-right-up-bold" className="text-lg" />
                        Visit Website
                      </a>
                    </div>
                  </div>
                )}

                {/* Address & Contact */}
                <div className="col-md-6">
                  <div className="p-16 radius-12 bg-neutral-50 border h-100">
                    <div className="d-flex align-items-start gap-3 mb-12">
                      <div className="bg-white radius-8 p-8 border d-flex align-items-center justify-content-center">
                        <Icon icon="solar:map-point-wave-bold" className="text-success text-xl" />
                      </div>
                      <h6 className="text-sm fw-bold text-dark mb-0 pt-8 uppercase">Venue Location</h6>
                    </div>
                    <p className="text-secondary-light mb-0 fw-medium ps-40">
                      {typeof event.location === 'object' ? (event.location?.address || JSON.stringify(event.location)) : (event.location || "-")}
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="p-16 radius-12 bg-neutral-50 border h-100">
                    <div className="d-flex align-items-start gap-3 mb-12">
                      <div className="bg-white radius-8 p-8 border d-flex align-items-center justify-content-center">
                        <Icon icon="solar:letter-bold" className="text-primary text-xl" />
                      </div>
                      <h6 className="text-sm fw-bold text-dark mb-0 pt-8 uppercase">Contact Details</h6>
                    </div>
                    <div className="ps-40">
                      <pre className="text-secondary-light mb-0 fw-medium" style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit', fontSize: '0.875rem' }}>
                        {event.contactDetails || "No contact information provided."}
                      </pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Add Modal */}
        {showAddModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-lg modal-dialog-centered">
              <div className="modal-content radius-16 border-0 shadow-lg">
                <div className="modal-header border-bottom py-16 px-24 text-white radius-top-16 d-flex align-items-center justify-content-between"
                  style={{ background: "linear-gradient(135deg, #000000 0%, #bb0007 50%, #ed1c24 100%)" }}
                >
                  <h5 className="modal-title fw-bold text-white mb-0">Add New {activeTab === 'stall' ? 'Stall' : 'Visitor'} Entry</h5>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowAddModal(false)}></button>
                </div>
                <div className="modal-body p-24 overflow-auto" style={{ maxHeight: '70vh' }}>
                  <form className="row gy-4">
                    <div className="col-md-6 text-start">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Name <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="name"
                        className={`form-control radius-8 ${errors.name ? 'is-invalid' : ''}`}
                        placeholder="Enter Name"
                        value={newEntry.name}
                        onChange={handleInputChange}
                      />
                      {errors.name && <div className="invalid-feedback">{errors.name}</div>}
                    </div>
                    <div className="col-md-6 text-start">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Company Name</label>
                      <input
                        type="text"
                        name="companyName"
                        className="form-control radius-8"
                        placeholder="Enter Company Name"
                        value={newEntry.companyName}
                        onChange={handleInputChange}
                      />
                    </div>
                    <div className="col-md-6 text-start">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Mobile Number <span className="text-danger">*</span></label>
                      <input
                        type="text"
                        name="mobileNo"
                        className={`form-control radius-8 ${errors.mobileNo ? 'is-invalid' : ''}`}
                        placeholder="Enter Mobile"
                        value={newEntry.mobileNo}
                        onChange={handleInputChange}
                      />
                      {errors.mobileNo && <div className="invalid-feedback">{errors.mobileNo}</div>}
                    </div>
                    <div className="col-md-6 text-start">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Email <span className="text-danger">*</span></label>
                      <input
                        type="email"
                        name="email"
                        className={`form-control radius-8 ${errors.email ? 'is-invalid' : ''}`}
                        placeholder="Enter Email"
                        value={newEntry.email}
                        onChange={handleInputChange}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    {activeTab === 'stall' && (
                      <>
                        <div className="col-md-6">
                          <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Product</label>
                          <Select
                            options={productOptions}
                            styles={selectStyles()}
                            placeholder="Select Product"
                            value={productOptions.find(opt => opt.value === newEntry.product) || null}
                            onChange={(sel) => handleInputChange({ target: { name: 'product', value: sel ? sel.value : "" } })}
                          />
                        </div>
                        <div className="col-md-6">
                          <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Stall Type</label>
                          <Select
                            options={stallTypeOptions}
                            styles={selectStyles()}
                            placeholder="Select Type"
                            value={stallTypeOptions.find(opt => opt.value === newEntry.stallType) || { value: 'Normal', label: 'Normal' }}
                            onChange={(sel) => handleInputChange({ target: { name: 'stallType', value: sel ? sel.value : "" } })}
                          />
                        </div>
                        <div className="col-md-6 text-start">
                          <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Choice of Stall <span className="text-danger">*</span></label>
                          <input
                            type="number"
                            name="stallNo"
                            className={`form-control radius-8 ${errors.stallNo ? 'is-invalid' : ''}`}
                            placeholder="Enter Stall No"
                            value={newEntry.stallNo}
                            onChange={handleInputChange}
                          />
                          {errors.stallNo && <div className="invalid-feedback">{errors.stallNo}</div>}
                        </div>
                      </>
                    )}

                    <div className="col-12">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Address</label>
                      <textarea className="form-control radius-8" name="address" rows="2" placeholder="Enter Full Address" value={newEntry.address} onChange={handleInputChange}></textarea>
                    </div>

                    <div className="col-md-4">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">City</label>
                      <input type="text" className="form-control radius-8" name="city" placeholder="Enter City" value={newEntry.city} onChange={handleInputChange} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">State</label>
                      <input type="text" className="form-control radius-8" name="state" placeholder="Enter State" value={newEntry.state} onChange={handleInputChange} />
                    </div>
                    <div className="col-md-4">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Pincode</label>
                      <input type="text" className="form-control radius-8" name="pincode" placeholder="Enter Pincode" value={newEntry.pincode} onChange={handleInputChange} />
                    </div>

                    <div className="col-md-6 text-start">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Payment Status</label>
                      <Select
                        options={[
                          { value: "Free", label: "Free" },
                          { value: "Cash", label: "Cash" },
                          { value: "UPI", label: "UPI" }
                        ]}
                        value={{ value: newEntry.paymentType, label: newEntry.paymentType }}
                        onChange={(sel) => handleInputChange({ target: { name: 'paymentType', value: sel.value } })}
                        styles={selectStyles()}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Remarks</label>
                      <textarea className="form-control radius-8" name="remarks" rows="1" placeholder="Enter Remarks" value={newEntry.remarks} onChange={handleInputChange}></textarea>
                    </div>
                    {newEntry.paymentType === 'UPI' && (
                      <div className="col-md-6 text-start">
                        <label className="form-label fw-bold small text-secondary-light uppercase mb-4">Upload Proof <span className="text-danger">*</span></label>
                        <div className="d-flex align-items-center gap-3">
                          <div
                            className="upload-btn border radius-8 d-flex align-items-center justify-content-center bg-light"
                            style={{ width: "100px", height: "100px", position: "relative", cursor: "pointer", overflow: "hidden" }}
                            onClick={() => document.getElementById('stallPaymentProof').click()}
                          >
                            {newEntry.paymentScreenshot ? (
                              <img src={newEntry.paymentScreenshot} alt="proof" className="w-100 h-100 object-fit-cover" />
                            ) : (
                              <div className="text-center text-secondary-light">
                                <Icon icon="solar:camera-bold" className="text-2xl mb-1" />
                                <div className="text-xs">Upload</div>
                              </div>
                            )}
                          </div>
                          <input type="file" id="stallPaymentProof" hidden accept="image/*" onChange={handleImageUpload} />
                          {newEntry.paymentScreenshot && (
                            <button
                              type="button"
                              className="btn btn-sm btn-danger-focus text-danger-main radius-4 p-4"
                              onClick={() => setNewEntry(prev => ({ ...prev, paymentScreenshot: null }))}
                            >
                              <Icon icon="solar:trash-bin-trash-bold" />
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                  </form>
                </div>
                <div className="modal-footer border-top p-16">
                  <button type="button" className="btn btn-secondary radius-8 px-24 font-weight-bold" onClick={() => setShowAddModal(false)}>Cancel</button>
                  <button type="button" className="btn radius-8 px-32 fw-bold shadow-sm d-flex align-items-center gap-2" style={{ backgroundColor: "#f7e7da", color: "black", fontWeight: "600" }} onClick={handleAddEntry}>
                    <Icon icon="ic:baseline-plus" className="text-xl" />
                    Add Entry
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Products List Modal */}
        {showProductsModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content radius-16 border-0 shadow-lg">
                <div className="modal-header border-bottom py-16 px-24 text-white radius-top-16 d-flex align-items-center justify-content-between"
                  style={{ background: "linear-gradient(135deg, #000000 0%, #bb0007 50%, #ed1c24 100%)" }}
                >
                  <h5 className="modal-title fw-bold text-white mb-0">Products List</h5>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowProductsModal(false)}></button>
                </div>
                <div className="modal-body p-24" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                  <div className="d-flex flex-wrap gap-2">
                    {event.products?.map((p, idx) => (
                      <span key={idx} className="badge bg-light text-dark border px-12 py-8 radius-4" style={{ fontSize: '11px' }}>
                        {typeof p === 'object' ? p.productName : p}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="modal-footer border-top p-16">
                  <button type="button" className="btn btn-secondary radius-8 px-24 font-weight-bold" onClick={() => setShowProductsModal(false)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Groups List Modal */}
        {showGroupsModal && (
          <div className="modal show d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 }}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content radius-16 border-0 shadow-lg">
                <div className="modal-header border-bottom py-16 px-24 text-white radius-top-16 d-flex align-items-center justify-content-between"
                  style={{ background: "linear-gradient(135deg, #000000 0%, #bb0007 50%, #ed1c24 100%)" }}
                >
                  <h5 className="modal-title fw-bold text-white mb-0">Groups List</h5>
                  <button type="button" className="btn-close btn-close-white" onClick={() => setShowGroupsModal(false)}></button>
                </div>
                <div className="modal-body p-24" style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                  <div className="d-flex flex-wrap gap-2">
                    {event.groups?.map((g, idx) => (
                      <span key={idx} className="badge bg-light text-dark border px-12 py-8 radius-4" style={{ fontSize: '11px' }}>
                        {typeof g === 'object' ? g.groupName : g}
                      </span>
                    ))}
                  </div>
                </div>
                <div className="modal-footer border-top p-16">
                  <button type="button" className="btn btn-secondary radius-8 px-24 font-weight-bold" onClick={() => setShowGroupsModal(false)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ExpoViewLayer;
